
import {  GET_ALL_COMPANY_ERROR, GET_ALL_COMPANY_SUCCESS, GET_ALL_COMPANY_POST_ERROR ,NEW_COMPANY_SUCCESS} from "../actions/types";

export default (state = {  
    error: null,
    status:[],
    addComp:{},
    success:false,
}, action) => {
    switch (action.type) {
        case GET_ALL_COMPANY_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: action.payload.message,
            };
            break;
        case GET_ALL_COMPANY_SUCCESS:
            return {
                ...state,
                error: state.error,
                loading:false,
                status: action.payload,
                success:true,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Retrieve Successfully',
            };
            break;
            case NEW_COMPANY_SUCCESS:
                return {
                    ...state,
                    error: state.error,
                    loading:false, 
                    success:true,
                    addComp:action.payload,
                    isSnackbarError: false,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: 'New Company Added Successfully',
                };
                break;
            
        case GET_ALL_COMPANY_POST_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Retrieve Error | ' + state.error,
            };
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/getAllCompanyReducer.js